import React, { useState, useEffect } from 'react';
import ReactModal from 'react-modal';
import { listConfigurations, enableConfiguration, deleteConfiguration, runCronJob } from '../../actions/configurationActions';
import { getForms } from '../../actions/formActions';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import SearchBoxWithListing from '../Common/SearchBoxWithListing';
import { FaTimes, FaPlus } from 'react-icons/fa'; // Importing the plus icon

const ManageConfiguration = (props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const configLocationPath = pathname.split('/').filter(Boolean)[0];

    const searchBoxKey = configLocationPath == "configurations" ? "configuration_search_form" : "master_configuration_search_form";
    const listFormKey = configLocationPath == "configurations" ? "configuration_list_form" : "master_configuration_list_form";

    const [isModalOpen, setIsModalOpen] = useState(false);
    const configurationState = useSelector((state) => state.configuration);
    const formState = useSelector((state) => state.forms);
    const { formJson = {} } = formState;
    const searchBoxJson = formJson[searchBoxKey] || {};
    const { listing: listingGlobal = {} } = configurationState;
    const listing = listingGlobal[configLocationPath];
    const { data = {} } = searchBoxJson;
    const { section = [] } = data;
    const [firstSection = {}] = section;
    const { fields = [] } = firstSection;
    const addIconField = fields.filter(field => field.id == 'addIcon');
    const showAddIcon = addIconField.length > 0;
    const [{ label = '' } = {}] = addIconField;

    const actionsHandling = (action, rowData) => {
        const { enabled = false, configurationId = '', type = '', apiKey = '' } = rowData;
        switch (action.id) {
            case "enabled": {
                dispatch(enableConfiguration({ enabled, configurationId }, configLocationPath));
                break;
            }
            case "delete": {
                dispatch(deleteConfiguration({ configurationId }, configLocationPath));
                break;
            }
            case "edit": {
                window.open(`/${configLocationPath}/edit?id=` + configurationId, "_blank", "noreferrer");
                break;
            }
            case "copy": {
                window.open(`/${configLocationPath}/copy?id=` + configurationId, "_blank", "noreferrer");
                break;
            }
            case "run": {
                if (type === "CRON_JOB") {
                    dispatch(runCronJob(configurationId))
                } else if (type === "ZERODHA") {
                    window.open(`https://kite.zerodha.com/connect/login?v=3&api_key=${apiKey}
`, "_blank")
                } else {
                    window.open('/strategy?id=' + configurationId, "_blank", "noreferrer");
                }
                break;
            }
        }
    }

    const listApi = (data) => {
        return dispatch(listConfigurations(data, listFormKey, configLocationPath));
    }

    const handleAdd = () => {
        navigate(`/${configLocationPath}/add`)
    }

    return (
        <div style={{ position: 'relative', paddingBottom: showAddIcon ? '80px' : '0px' }}> {/* Added padding-bottom */}
            <SearchBoxWithListing
                searchBoxKey={searchBoxKey}
                listFormKey={listFormKey}
                fetchForm={getForms}
                listApi={listApi}
                searchBoxJson={searchBoxJson}
                listingData={listing}
                actionsHandling={actionsHandling}
            />

            {/* Floating Add Button */}
            {showAddIcon ? <div
                onClick={() => handleAdd()}
                style={{
                    position: 'fixed',
                    bottom: '20px',
                    right: '20px',
                    backgroundColor: 'green',
                    color: 'white',
                    borderRadius: '50%',
                    padding: '15px',
                    cursor: 'pointer',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                    zIndex: 1000,
                }}
                title={label}
            >
                <FaPlus size={20} />
            </div> : ''}
            <ReactModal
                isOpen={isModalOpen}
                onRequestClose={() => setIsModalOpen(false)}
                style={{
                    content: {
                        position: 'relative',
                        inset: 'auto',
                        margin: '0',
                        transform: 'none',
                        width: 'min(900px, 92vw)',
                        maxHeight: '90vh',
                        overflowY: 'auto',
                        padding: '20px',
                    },
                    overlay: {
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 2000,
                    },
                }}
            >
                {/* Close Icon */}
                <button
                    onClick={() => setIsModalOpen(false)}
                    style={{
                        position: 'absolute',
                        top: '10px',
                        right: '10px',
                        border: 'none',
                        background: 'none',
                        cursor: 'pointer',
                        fontSize: '18px',
                    }}
                    aria-label="Close"
                >
                    <FaTimes />
                </button>
                <div>
                    {/* <SearchBox
                        searchBoxJson={searchBoxKey}
                        options={options}
                        placeholder="Search and select"
                        onOptionSelect={handleOptionSelect}
                        multiple={false}
                        searchable={true}
                    /> */}
                    <button
                        className="btn btn-secondary mt-3"
                        onClick={() => setIsModalOpen(false)}
                    >
                        Close
                    </button>
                </div>
            </ReactModal>
        </div>
    );
}

export default ManageConfiguration;
